import { useEffect, useRef, useState } from "react";
import "./FormEditor.css";
import { FormHeader } from "../form-header/FormHeader";
import { FormSidebar } from "../form-sidebar/FormSidebar";
import { selectUIStates, selectUser, setUIStates, uiStatesType } from "../../redux/features/appData";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { QuestionPicker } from "../question-picker/QuestionPicker";
import { FormContent } from "../form-content/FormContent";
import { Toaster } from "react-hot-toast";
import { QuestionSettings } from "../question-settings/QuestionSettings";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { Form, useNavigate } from "react-router-dom";
import { QuestionDesign } from "../question-design/QuestionDesign";
import { QuestionComments } from "../question-comments/QuestionComments";
import { useScreenWidth } from "../../hooks/useScreenWidth";
import { isMobile } from "../../utils/screens";
import { set } from "react-datepicker/dist/date_utils";

const MIN_WIDTH = 700;

type FormEditorProps = {
}

export const FormEditor = ({} : FormEditorProps) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const screenWidth = useScreenWidth();

    const storeUser = useSelector(selectUser);
    const uiStates = useSelector(selectUIStates);

    const uiStatesRef = useRef<uiStatesType | undefined>(undefined);

    const [tooSmall, setTooSmall] = useState(false);

    useEffect(() => {

        // if not logged in bounce there
        if (!storeUser) {
            navigate("/login");
            return;
        }

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && uiStatesRef.current) {
                console.log("[FormEditor] Escape key pressed, uiStatesRef: ", uiStatesRef.current);
                dispatch(setUIStates({
                    ...uiStatesRef.current,
                    commentMode: false
                }));

                e.stopPropagation();
            }
        })

        return () => {
            document.removeEventListener("keydown", () => {});
        }
    }, []);

    useEffect(() => {
        uiStatesRef.current = uiStates;
    }, [uiStates]);

    useEffect(() => {
        if (isMobile()) {
            setTooSmall(false);
        }

        setTooSmall(screenWidth < MIN_WIDTH) 

        console.log("[FormEditor] screenWidth: ", screenWidth);
    }, [screenWidth]);


    if (storeUser) {
        document.body.className = storeUser.theme;
    }
    
    return (
        <>
            {tooSmall &&
                <div className="form-editor-too-small">
                    <div className="form-editor-too-small-title">
                        <b>effno</b>&nbsp;works best with a bigger screen 👍
                    </div>
                </div>
            }

            {!tooSmall && 
                <div id="form-editor">
                
                    <div className="form-editor-header">
                        <FormHeader />
                    </div>
                    <div className="form-editor-body">
                        <div className="form-editor-sidebar">
                            <DndProvider backend={HTML5Backend}>
                                <FormSidebar />
                            </DndProvider>
                        </div>
                        <div className={uiStates.mobileLayout ? 
                            "form-editor-content-mobile" : "form-editor-content"}>
                            <FormContent />
                        </div>
                        <div className="form-editor-settings">
                            {uiStates.viewingBuild && <QuestionSettings />}
                            {uiStates.viewingDesign && <QuestionDesign />}
                            {uiStates.viewingComments && <QuestionComments />}
                        </div>
                    </div>
                        
                    {uiStates.questionPickerOpen &&
                        <QuestionPicker 
                            isOpen={uiStates.questionPickerOpen}
                            onClose={
                                () => dispatch(setUIStates({...uiStates, questionPickerOpen: false}))
                            }
                        />
                    }
                </div>
            }

            <Toaster />

        </>
        
    )
}